import { PublishingStatus } from '@wix/wix-data-schema-types'

export const MAX_LENGTH_OF_COLLECTION_ID_AND_NAME = 36

export const PUBLISHING_PLUGIN_ID = 'publishing'

export const DEFAULT_PUBLISHING_MODE = PublishingStatus.PUBLISHED
